import { useReactiveVar } from '@apollo/client';

import { userStateVar } from 'core/state/userState';
import { UserRole } from 'types';

/**
 * ТЗ 0084 — кто работает с лидами Kommo. Зеркало `LEAD_ROLES` бэкенда
 * (`crm/services/lead_access.py`): любой продавец — Admin, SalesManager,
 * AccountManager — видит всех лидов и пишет любому. FinanceManager, HR и
 * методист — нет: ни пункта меню, ни маршрута, ни запроса.
 *
 * Меню, маршрут и палитра берут список ТОЛЬКО отсюда — три места не имеют
 * права разойтись. Скрытие — UX, авторитет у бэкенда; но гейт нужен и чтобы
 * НЕ слать запрос с чужой роли (отказ рисовал бы ошибку поверх экрана).
 */
export const LEAD_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.SALESMANAGER,
  UserRole.ACCOUNTANT,
];

/**
 * Вкладка «Kommo»: синхронизация сейчас, сопоставление пользователей, повтор
 * примечаний — только Admin (`ADMIN_ROLES` бэкенда).
 */
export const LEAD_ADMIN_ROLES: UserRole[] = [UserRole.ADMIN];

export interface ILeadPermissions {
  /** Раздел «Лиды»: список, карточка, SMS лиду. */
  canUse: boolean;
  /** Вкладка «Kommo». */
  isAdmin: boolean;
}

const hasAny = (roles: UserRole[], allowed: UserRole[]): boolean =>
  roles.some((role) => allowed.includes(role));

/** Роли без React — для чистых проверок и тестов. */
export const leadPermissionsFor = (roles: UserRole[]): ILeadPermissions => ({
  canUse: hasAny(roles, LEAD_ROLES),
  isAdmin: hasAny(roles, LEAD_ADMIN_ROLES),
});

export const useLeadPermissions = (): ILeadPermissions => {
  const userState = useReactiveVar(userStateVar);
  return leadPermissionsFor((userState.me?.roles ?? []) as UserRole[]);
};
